<template>
  <v-container class="mt-4 px-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title class="text-subtitle-1">
            <v-toolbar-title>Lista de teachers activos</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="getTeachers()" small>Consultar</v-btn>
          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="6" lg="4">
                <v-text-field
                  v-model="search"
                  label="Buscar"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-data-table
              dense
              elevation-0
              :headers="headers"
              :items="teachers"
              :search="search"
              item-key="id_teacher"
              class="elevation-0 mt-2"
            >
              <template v-slot:item.total_comentarios="{ item }">
                <v-chip small :color="item.total_comentarios > 0 ? 'primary' : 'grey lighten-2'" dark>
                  {{ item.total_comentarios || 0 }}
                </v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  color="primary"
                  small
                  rounded
                  class="text-capitalize"
                  @click="abrirComentarios(item)"
                >
                  <v-icon left small>mdi-comment-text-outline</v-icon>
                  Comentarios
                </v-btn>
              </template>

              <template v-slot:no-data>
                <v-btn color="primary" @click="getTeachers()" small>Consultar</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogComentarios" max-width="560px" v-if="teacherSeleccionado">
      <v-card>
        <v-card-title primary-title class="text-subtitle-1">
          Comentarios — {{ teacherSeleccionado.nombre_completo }}
        </v-card-title>

        <v-card-text>
          <div
            v-if="comentarios.length"
            class="comentarios-scroll mb-4"
          >
            <div
              v-for="(mensaje, i) in comentarios"
              :key="i"
              class="comentario-item pa-3 mb-3"
            >
              <div class="text-caption grey--text text--darken-1">
                <strong>{{ mensaje.nombre_usuario }}</strong>
                · {{ formatearFecha(mensaje.fecha_creacion) }}
              </div>
              <p class="mb-0 mt-1">{{ mensaje.comentario }}</p>
            </div>
          </div>
          <p v-else class="grey--text text--darken-1 mb-4">Sin comentarios aún.</p>

          <v-textarea
            v-model="nuevoComentario"
            filled
            dense
            :rows="3"
            auto-grow
            label="Escribir comentario"
            hide-details
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-btn color="red" rounded small dark class="text-capitalize" @click="cerrarComentarios()">
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            rounded
            small
            class="text-capitalize"
            :disabled="!nuevoComentario || !nuevoComentario.trim()"
            @click="agregarComentario()"
          >
            Agregar comentario
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

export default {
  components: {
    Alerta,
    carga,
  },

  mixins: [validarErrores],

  data: () => ({
    search: '',
    teachers: [],
    comentarios: [],
    teacherSeleccionado: null,
    dialogComentarios: false,
    nuevoComentario: '',
    headers: [
      { text: 'ID', value: 'id_teacher' },
      { text: 'Teacher', value: 'nombre_completo' },
      { text: 'Plantel', value: 'plantel' },
      { text: 'Teléfono', value: 'telefono1' },
      { text: 'Comentarios', value: 'total_comentarios', align: 'center' },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],
  }),

  created() {
    this.getTeachers()
  },

  methods: {
    getTeachers() {
      this.cargar = true
      this.$http.get('lms.teachers.activos.soporte').then(response => {
        this.teachers = (response.data || []).filter(
          (t) => Number(t.activo) === 1 && Number(t.activo_sn) === 1
        )
      }).catch(error => {
        this.validarError(error.response.data.message)
      }).finally(() => {
        this.cargar = false
      })
    },

    abrirComentarios(item) {
      this.teacherSeleccionado = item
      this.nuevoComentario = ''
      this.dialogComentarios = true
      this.cargarComentarios(item.id_teacher)
    },

    cargarComentarios(id_teacher) {
      this.cargar = true
      this.$http.get(`lms.teachers.activos.comentarios/${id_teacher}`).then(response => {
        this.comentarios = response.data
      }).catch(error => {
        this.validarError(error.response.data.message)
      }).finally(() => {
        this.cargar = false
      })
    },

    agregarComentario() {
      if (!this.nuevoComentario || !this.nuevoComentario.trim()) {
        this.validarErrorDirecto('Escribe un comentario')
        return
      }

      const payload = {
        id_teacher: this.teacherSeleccionado.id_teacher,
        comentario: this.nuevoComentario,
        nombre_usuario: this.getdatosUsuarioERPERP.nombre_completo,
      }

      this.cargar = true
      this.$http.post('lms.teachers.activos.comentario', payload).then(response => {
        this.comentarios = response.data.comentarios || []
        this.nuevoComentario = ''
        this.validarSuccess(response.data.message)
        this.getTeachers()
      }).catch(error => {
        this.validarError(error.response.data.message)
      }).finally(() => {
        this.cargar = false
      })
    },

    cerrarComentarios() {
      this.dialogComentarios = false
      this.teacherSeleccionado = null
      this.comentarios = []
      this.nuevoComentario = ''
    },

    formatearFecha(fecha) {
      if (!fecha) return ''
      const d = new Date(fecha)
      if (Number.isNaN(d.getTime())) return fecha
      return d.toLocaleString('es-MX', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
  },
}
</script>

<style scoped>
.comentarios-scroll {
  max-height: 320px;
  overflow-y: auto;
}

.comentario-item {
  background: #f5f5f5;
  border-radius: 8px;
}
</style>
